import { Address } from '@api/generated/graphql';
import { getCountryFromStateCode } from 'src/constants/countryWithStates';

/*
We will receive this address from bandwidth API Bandwidth API doesn't store country and assume country to be either US or Canada.
To display it to the user we need to populate the country field based on the state code.
This function will convert the address received from BE and populate the country field.
*/
export function convertAddressAndPopulateCountry(
  address: Address | undefined | null,
) {
  return {
    street: address?.street ?? '',
    city: address?.city ?? '',
    state: address?.state ?? '',
    zip: address?.zip ?? '',
    unit: address?.unit ?? '',
    country: address?.state ? getCountryFromStateCode(address?.state) : '',
  };
}
